import { VStack } from "@chakra-ui/react";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SideBarItems } from "../utils/utils";

const Sidebar = React.memo(() => {
  return (
    <VStack align="start">
      {SideBarItems?.map(({ path, icon: Icon, label, activeFor = [] }) => (
        <NavLink key={path} to={path} icon={Icon} activeFor={activeFor}>
          {label}
        </NavLink>
      ))}
    </VStack>
  );
});

const NavLink = ({ to, icon: Icon, children, activeFor = [] }) => {
  const location = useLocation();
  const locSegment = location.pathname.split("/")[1] || "";
  const pathSegment = to.split("/")[1] || "";
  const isActive = pathSegment === locSegment || activeFor.includes(locSegment);
  return (
    <Link to={to} className={isActive ? "activelink" : "link"}>
      <Icon size={20} />
      {children}
    </Link>
  );
};

export default Sidebar;
